import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';
import { service } from '@ember/service';
import type { WellnessInsightsComponentDefinitionExtension as WellnessInsightsComponentDefinition } from 'tio-data/data/resources/wellness-insights-component-definition.ext';

interface S {
  Args: { componentDefinition: WellnessInsightsComponentDefinition };
}

export const proseClasses = 'tio-prose max-w-full *:text-base';

export default class DashboardItem extends Component<S> {
  @service declare intl: IntlService;

  translate = (translation: string, args: Record<string, string> = {}): string => {
    const options = { ...args, htmlSafe: true };
    const fullTranslation = ['wellness_insights', 'dashboard', 'components', translation].join('.');

    return this.intl.t(fullTranslation, options);
  };
}
